import React, { useMemo } from 'react'
import { SectionStatusCode } from '@mortgage-pos/types'
import { useStoreState, useStoreActions } from '@mortgage-pos/ui/store'

const AppProgress = () => {
  const { finished } = useStoreState((state) => state.questionnaire)
  const { sectionStatuses } = useStoreState((state) => state.pageSections)
  const { navigateToSection } = useStoreActions(
    (actions) => actions.pageSections
  )
  const sectionNames = useMemo(
    () => Object.keys(sectionStatuses),
    [sectionStatuses]
  )

  return (
    <nav className={`app-progress ${finished ? '--finished' : ''}`}>
      <ul className="app-progress__sections-list">
        {sectionNames.map((sectionName) => {
          const statuses = sectionStatuses[sectionName]
          const isActive = statuses.has(SectionStatusCode.active)
          const hasBeenVisited = statuses.has(SectionStatusCode.visited)
          const modifierClass = calcModifierClass(statuses)

          return (
            <li
              className={`app-progress__section ${modifierClass}`}
              onClick={() => {
                if (hasBeenVisited && !isActive && !finished) {
                  navigateToSection(sectionName)
                }
              }}
              key={`progress-${sectionName}`}
            >
              <div className="app-progress__status-indicator">
                <img
                  className="app-progress__check"
                  src="/assets/check-mark.svg"
                  alt="step completion indicator"
                />
                <div className="app-progress__circle"></div>
              </div>
              <div className="app-progress__status-label">{sectionName}</div>
            </li>
          )
        })}
      </ul>
    </nav>
  )
}

function calcModifierClass(statuses: Set<SectionStatusCode>) {
  // NOTE: if-statements are organized in order of precedence
  // (active > complete > visited)
  if (statuses.has(SectionStatusCode.active)) {
    return '--active'
  }

  if (statuses.has(SectionStatusCode.complete)) {
    return '--complete'
  }

  if (statuses.has(SectionStatusCode.visited)) {
    return '--visited'
  }

  return ''
}

export default AppProgress
